/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { jsx } from '@emotion/react'

import { EuiDescribedFormGroup, EuiFieldPassword, EuiSelect } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { CuiFormField } from '@modules/cui/forms'
import { CuiTitleWithBadge } from '@modules/cui/TitleWithBadge'
import { DocLink } from '@modules/doclinks'

import { labels, messages, sections } from '../../authProviderMessages'
import { euiDescribedFormGroupFieldPaddingNoneStyle } from '../../authProviders.styles'

import type { FunctionComponent } from 'react'

const SSLConfiguration: FunctionComponent = () => (
  <EuiDescribedFormGroup
    css={euiDescribedFormGroupFieldPaddingNoneStyle}
    title={
      <CuiTitleWithBadge>
        <FormattedMessage {...sections.sslConfiguration} />
      </CuiTitleWithBadge>
    }
    description={
      <FormattedMessage
        {...sections.sslConfigurationDescription}
        values={{
          learnMore: (
            <DocLink link='samlProviderSslConfigurationDocLink'>
              <FormattedMessage {...messages.learnMore} />
            </DocLink>
          ),
        }}
      />
    }
  >
    <CuiFormField
      label={<FormattedMessage {...labels.sslCertificateUrl} />}
      name='ssl_certificate_url'
      helpText={<FormattedMessage {...labels.sslCertificateUrlHelpText} />}
    />

    <CuiFormField
      label={<FormattedMessage {...labels.sslCertificateUrlTruststoreType} />}
      name='ssl_certificate_url_truststore_type'
      component={EuiSelect}
      options={[{ text: 'jks' }, { text: 'PKCS12' }]}
      helpText={<FormattedMessage {...labels.sslCertificateUrlTruststoreTypeHelpText} />}
    />

    <CuiFormField
      label={<FormattedMessage {...labels.sslCertificateUrlTruststorePassword} />}
      name='ssl_certificate_url_truststore_password'
      component={EuiFieldPassword}
      helpText={<FormattedMessage {...labels.sslCertificateUrlTruststorePasswordHelpText} />}
    />
  </EuiDescribedFormGroup>
)

export default SSLConfiguration
